import React, {useRef} from "react";
import styled from "@emotion/styled";
import {useTheme} from "@emotion/react";
import ClassBadge from "../../_common/component/ClassBadge";
import moment from "moment";
import {getPercentage} from "../../../common";
import {useNavigate} from "react-router-dom";
import {useMobileDetect} from "../../../utils/Hooks";
import {getImageUrl} from "../../../context/ApplicationContextProvider";
import {useDialogContext} from "../../../context/DialogContextProvider";
import {lang} from "../../../lang";
import HoverBlueSecretNote from "../../_common/component/HoverBlueSecretNote";

/*
    props
    course : {} = 하나의 course
 */
const CourseCard = (props) => {
    const {is_mobile} = useMobileDetect();
    const {alert} = useDialogContext();
    const navigate = useNavigate();

    // ref
    const is_expired = useRef(props.course.is_expired);
    const expire_date = useRef(moment(props.course.rental_expire_time).format("YYYY-MM-DD hh:mm"));

    // css style
    const {view} = useComponentStyle();

    return (
        <view.CourseCard>
            <view.BadgeRow
                onClick={async () => {
                    if (!is_expired.current) {
                        navigate(`/course/${props.course.course_id}`);
                    } else {
                        await alert(lang.course_list.expired_course);
                    }
                }}>
                <ClassBadge is_expired={is_expired.current} />
                <span>수강률 {getPercentage(props.course.attendance_rate)}%</span>
            </view.BadgeRow>
            <view.TitleRow
                onClick={async () => {
                    if (!is_expired.current) {
                        navigate(`/course/${props.course.course_id}`);
                    } else {
                        await alert(lang.course_list.expired_course);
                    }
                }}>
                <view.CourseImg course={props.course} />
                <view.TitleWrap>
                    <view.Title>{props.course.course_short_title}</view.Title>
                    <view.SubTitle>{props.course.course_title}</view.SubTitle>
                </view.TitleWrap>
                <view.PlayImg>
                    <img src={`${getImageUrl("image/course/ic_play_b_x3.png")}`} alt="재생 버튼" />
                </view.PlayImg>
            </view.TitleRow>
            <view.RangeRow>
                <view.ExpireDateView>
                    ~{expire_date.current}
                    {is_mobile && <br />}
                    수강가능
                </view.ExpireDateView>
                {props.course.course_document_url && (
                    <a href={props.course.course_document_url} target={"_blank"} rel="noreferrer">
                        <HoverBlueSecretNote />
                    </a>
                )}
            </view.RangeRow>
        </view.CourseCard>
    );
};

export default CourseCard;

export const useComponentStyle = () => {
    const theme = useTheme();
    return {
        view: {
            CourseCard: styled.div({
                boxSizing: "border-box",
                width: "100%",
                border: `1px solid ${theme.colors.lg3}`,
                borderBottom: `1px solid ${theme.colors.dg2}`,
                padding: "1.2em 1.5em",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 25%)",
                display: "flex",
                flexDirection: "column",
                backgroundColor: theme.colors.w,
                transition: "all .2s",
                "@media (max-width: 320px)": {
                    padding: ".8em 1em",
                },
            }),
            BadgeRow: styled.div({
                cursor: "pointer",
                width: "100%",
                display: "flex",
                alignItems: "center",
                span: {
                    fontSize: theme.font_size.f14,
                    color: theme.colors.dg1,
                    marginLeft: ".5em",
                },
            }),
            TitleRow: styled.div({
                cursor: "pointer",
                width: "100%",
                display: "flex",
                flexWrap: "nowrap",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: ".8em",
                transition: "all .2s",
                "@media (max-width: 320px)": {
                    marginTop: ".3em",
                },
            }),
            CourseImg: styled.div((props) => ({
                background: `url(${
                    props.course.course_circle_image_url
                        ? props.course.course_circle_image_url
                        : "https://drv987r6zjtyw.cloudfront.net/static/v2/svg/search/logo_bear_b1.svg"
                }) center center / cover no-repeat`,
                width: "4em",
                height: "4em",
                minWidth: "4em",
                borderRadius: "50%",
            })),
            TitleWrap: styled.div({
                display: "flex",
                flexDirection: "column",
                width: "70%",
                padding: ".5em",
            }),
            Title: styled.span({
                display: "block",
                fontSize: theme.font_size.f17,
                fontWeight: "700",
                transition: "all .2s",
                "@media (max-width: 359px)": {
                    fontSize: theme.font_size.f15,
                },
                "@media (max-width: 330px)": {
                    fontSize: theme.font_size.f14,
                },
            }),
            SubTitle: styled.span({
                display: "block",
                fontSize: theme.font_size.f14,
                marginTop: ".5em",
                height: "30px",
                transition: "all .2s",
                "@media (max-width: 320px)": {
                    fontSize: theme.font_size.f13,
                },
            }),
            PlayImg: styled.div({
                width: "3em",
                height: "3em",
                minWidth: "3em",
                borderRadius: "50%",
                backgroundColor: theme.colors.play_background,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                img: {
                    width: "24px",
                    height: "24px",
                },
            }),
            RangeRow: styled.div({
                marginTop: ".8em",
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                transition: "all .2s",
                "@media (max-width: 320px)": {
                    marginTop: ".3em",
                },
            }),
            ExpireDateView: styled.div({
                color: theme.colors.dg2,
                fontSize: theme.font_size.f13,
                textOverflow: "hidden",
            }),
        },
    };
};
